export default __webpack_public_path__ + "static/media/newBlackFriday.b92d6c7f.png";